export const STARTSCHERM_I18N = {
    MIJN_GEGEVENS: 'Mijn gegevens',
    BEL_ONS: 'Bel ons',
    AFMELDEN: 'Afmelden',
    MIJN_BERICHTEN: 'Mijn berichten',
    VOOR_WIE_WERKEN: 'Voor wie wil u werken?',
    VOORWIE: {
        TITLE: 'Voor wie?',
        CHOOSE: 'Voor wie wil u werken?',
        CLEAR: 'Verwijder voor wie keuze',
        CLOSE: 'Sluiten',
        PLACEHOLDER: 'Kies een voor wie',
        CURRENT: 'Huidige keuze',
        CLEAR_CONDITION: 'Indien u een andere voor wie wilt selecteren moet u eerst de huidige voor wie wissen.'
    },
    HOEDANIGHEID: {
        CHOOSE: 'Onder welke hoedanigheid wilt u voor deze klant werken?'
    },
    COMPACT: 'Compact',
    TEST_PROFILE: {
        TITLE: 'Test profiel',
        CHOOSE: 'Kies een test profiel',
        CLEAR: 'Verwijder test profiel',
        CLOSE: 'Sluiten',
        PLACEHOLDER: 'Kies een test profiel',
        CURRENT: 'Huidige keuze',
        CLEAR_CONDITION: 'Indien u een ander test profiel wilt selecteren moet u eerst het huidige test profiel wissen.'
    },
    MAIL_ONS_DIALOG: {
        TITLE: 'Stel je vraag',
        FORM: {
            TIME: 'Tijdstip',
            USER: {
                NAME: 'Gebruiker',
                EMAIL: 'E-mail',
                PHONE: 'Telefoon',
                MOBILE_PHONE: 'GSM'
            },
            CLIENT: 'Klant waarvoor u werkte',
            CLIENT_PLACEHOLDER: 'Selecteer een klant',
            SUBJECT: 'Onderwerp',
            SUBJECT_PLACEHOLDER: 'Selecteer een onderwerp',
            SUBJECT_INVALID: 'Het veld "onderwerp" is een verplicht veld',
            BODY: 'Uw bericht',
            NOTIFICATION: 'Het dossier en/of pagina binnen het e-loket wordt automatisch toegevoegd aan dit rapport.',
            CONTACT: 'Contacteer mij wanneer dit probleem opgelost is',
            ATTACHMENTS: 'Bijlagen',
            SEND: 'Versturen',
            CANCEL: 'Annuleren',
            SELECTFILES: 'Selecteer bestanden',
            DELETEFILE: 'Verwijder bestand'
        },
        SEND_ERROR: 'Er was een probleem met het versturen van het formulier, gelieve opnieuw te versturen.',
        SEND_SUCCESS: 'Je formulier is succesvol verzonden.',
        SEND_ERROR_MAIL: 'Er was een probleem met het versturen van het formulier. Gelieve later opnieuw te proberen of te e-mailen naar: info@lv.vlaanderen.be'
    },
    HEADER_WIDGET: {
        USER: {
            TITLE: 'Mijn profiel',
            CLIENT_NUMBER: 'Klantnummer: {{ clientNumber }}',
            CLIENT_NUMBER_TOOLTIP: 'Klantnummer kopiëren',
            FORCE_ERROR: 'Forceer error',
            COMPACT: 'Compact',
            LOG_OUT: 'Afmelden'
        },
        HELP: {
            TITLE_BTN: 'Hulp nodig',
            TITLE: 'Hulp nodig?',
            CONTACT_DESCRIPTION: 'Neem contact op met ons.',
            HELP_PAGE: 'Help e-loket',
            CALL_US: 'Bel ons',
            MAIL_US: 'Mail ons',
            CLIENT_NUMBER_NOTIFICATION: 'Vermeld steeds op alle officiële communicatie je klantnummer:'
        }
    },
    GENERAL: {
        CANCEL: 'Annuleren'
    }
} as const;
